"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ingredient = void 0;
var measurement_1 = require("./models/measurement");
var prep_1 = require("./models/prep");
exports.Ingredient = {
    parse: function (ingredientString) {
        var tokens = ingredientString.split(' ');
        var newTitle = [];
        var quantity = null;
        var quantityParts = [];
        var prep = null;
        var measure = null;
        var measurments = Object.values(measurement_1.MEASUREMENT).map(function (value) { return value; });
        var preps = Object.values(prep_1.PREP).map(function (value) { return value; });
        tokens.map(function (token) { return token.toLowerCase(); }).forEach(function (token, i) {
            if (measurments.includes(token)) {
                measure = measurement_1.returnMeasurement(tokens[i]);
            }
            else if (preps.includes(token)) {
                prep = tokens[i];
            }
            else if (!isNaN(parseInt(token[0], 10))) {
                // Starts with a number
                // Need to handle 1 1/2 
                quantityParts.push(tokens[i]);
            }
            else {
                newTitle.push(tokens[i]);
            }
        });
        if (quantityParts.length > 0) {
            quantity = quantityParts.join(' ');
        }
        var title = newTitle.join(' ');
        return {
            title: title,
            prep: prep,
            quantity: quantity,
            measure: measure
        };
    },
};
